import { createContext, useContext } from 'react';

const NavigationStateContext = createContext({
  canGoBack: false,
  goBack: () => {},
  currentPage: 'home'
});

export const NavigationStateProvider = NavigationStateContext.Provider;

export function useNavigationState() {
  return useContext(NavigationStateContext);
}

export default NavigationStateContext;
